import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { connect } from "react-redux";
import Helper from "../functions/Helper.js";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
//import { withRouter } from 'react-router'
import { LinkContainer } from "react-router-bootstrap";

function Footer(props) {
  return (
    <div style={{ borderTop: "1px solid #eee" }} className="thg_full_width">
      <div style={{ marginTop: 40 }} className="ast-container ">
        <Row style={{ marginTop: 0, marginBottom: 0 }}>
          <Col lg={4} style={{ paddingBottom: 80 }}>
            <div
              style={{
                fontSize: 22,
                fontWeight: "600",
                marginBottom: 10,
                color: "var(--grey-900)",
              }}
            >
              Sneaker Geek App
            </div>
            <a href="/sneaker-geek/">
              <img
                height={600}
                width={600}
                className="lazyload"
                alt="SneakerGeek"
                style={{
                  flex: 1,
                  width: "100%",
                  maxWidth: 250,
                  marginBottom: 15,
                }}
                src={
                  __cdn__ + "/wp-content/uploads/2019/04/Sneaker-Geek-App-1.png"
                }
              />
            </a>
            <div style={{ fontSize: 16, marginBottom: 5, maxWidth: 300 }}>
              Get the "SneakerGeek" app and always stay up-to-date with new shoe
              releases!
            </div>
            <a href="https://itunes.apple.com/us/app/sneakergeek/id1451958183?mt=8">
              <img
                width={120}
                height={40}
                className="lazyload"
                alt="ios store"
                style={{ width: 140, marginTop: 10, marginRight: 10 }}
                src={`${__cdn__}/wp-content/uploads/2021/04/App-Store.svg`}
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.sneakergeek">
              <img
                width={564}
                height={168}
                className="lazyload"
                alt="google play store"
                style={{ width: 140, marginTop: 10 }}
                src={
                  __cdn__ +
                  "/wp-content/uploads/2019/04/google_play_badge_trimmed.png"
                }
              />
            </a>
          </Col>
          <Col lg={8}>
            <Row>
              <Col lg={6} style={{ paddingBottom: 80 }}>
                <div style={{ marginBottom: 10 }}>
                  <div
                    style={{
                      fontSize: 22,
                      color: "var(--grey-900)",
                      fontWeight: "600",
                    }}
                    to={"/shoe-reviews/"}
                  >
                    Latest Shoe Releases:
                  </div>
                </div>
                {Helper.ratingOrderBy(props.overview, "release_date", "desc")
                  .slice(0, 8)
                  .map((shoe) => {
                    return (
                      <div
                        key={shoe.shoe_id}
                        style={{ display: "flex", marginBottom: 8 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: Helper.get_color(
                              shoe.rating,
                              "bg"
                            ),
                            color: "#fff",
                            fontWeight: 600,
                            width: 50,
                            height: 35,
                            textAlign: "center",
                            fontSize: 16,
                            marginRight: 10,
                          }}
                        >
                          {Helper.printRating(shoe.rating)}
                        </div>
                        <Link
                          to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}
                          style={{
                            lineHeight: 1,
                            fontWeight: 600,
                            color: "var(--grey-800)",
                            fontSize: 16,
                            flex: 1,
                            display: "flex",
                            alignSelf: "center",
                          }}
                        >
                          {shoe.shoe_name}
                        </Link>
                      </div>
                    );
                  })}
                <div style={{ marginTop: 15 }}>
                  <Link
                    style={{
                      color: "var(--grey-700)",
                      fontSize: 16,
                      fontWeight: 700,
                    }}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      props.actions.searchtext("");
                    }}
                    to={"/shoe-reviews/"}
                  >
                    See All Latest Releases
                  </Link>
                </div>
              </Col>

              <Col lg={6} style={{ paddingBottom: 80 }}>
                <div style={{ marginBottom: 10 }}>
                  <div
                    style={{
                      fontSize: 22,
                      fontWeight: "600",
                      color: "var(--grey-900)",
                      marginBottom: 10,
                    }}
                  >
                    Best Shoes All-Time:
                  </div>
                </div>
                {Helper.ratingOrderBy(props.overview, "rating", "desc")
                  .slice(0, 8)
                  .map((shoe) => {
                    return (
                      <div
                        key={shoe.shoe_id}
                        style={{ display: "flex", marginBottom: 8 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: Helper.get_color(
                              shoe.rating,
                              "bg"
                            ),
                            color: "#fff",
                            fontWeight: 600,
                            width: 50,
                            height: 35,
                            textAlign: "center",
                            fontSize: 15,
                            marginRight: 10,
                          }}
                        >
                          {Helper.printRating(shoe.rating)}
                        </div>
                        <Link
                          to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}
                          style={{
                            lineHeight: 1.2,
                            fontWeight: 600,
                            flex: 1,
                            display: "flex",
                            color: "var(--grey-800)",
                            fontSize: 15,
                            alignSelf: "center",
                          }}
                        >
                          {shoe.shoe_name}
                        </Link>
                      </div>
                    );
                  })}
                <div style={{ marginTop: 15 }}>
                  <Link
                    onClick={() => {
                      window.scrollTo(0, 0);
                      props.actions.searchtext("");
                    }}
                    style={{
                      color: "var(--grey-700)",
                      fontSize: 16,
                      fontWeight: 700,
                    }}
                    to={"/shoe-reviews/?sortBy=rating&order=desc"}
                  >
                    See Ranking of All {props.overview.length} Shoes
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div
          style={{
            fontSize: 22,
            marginBottom: 15,
            fontWeight: "600",
            color: "var(--grey-900)",
          }}
        >
          <a
            style={{
              fontSize: 22,
              fontWeight: "600",
              color: "var(--grey-900)",
              marginBottom: 20,
            }}
            href="https://www.thehoopsgeek.com/category/basketball-shoes/"
          >
            Most Popular Basketball Shoe Articles:
          </a>
        </div>

        <div className="su-posts su-posts-related-loop">
          <div className="row related_header">
            <div
              className="col-lg-3 col-sm-6 col-12"
              style={{ marginBottom: "15px" }}
            >
              <div className="row" id="su-post-7422">
                <div className="col-6 col-sm-12">
                  <a href="https://www.thehoopsgeek.com/best-basketball-shoes/">
                    <img
                      width={300}
                      height={150}
                      src={
                        __cdn__ +
                        "/wp-content/uploads/2021/07/Under-Armour-Curry-9-300x150.jpeg"
                      }
                      className="su_related_thumbnail wp-post-image"
                      alt=""
                      loading="lazy"
                      srcSet={`${__cdn__}/wp-content/uploads/2021/07/Under-Armour-Curry-9-300x150.jpeg 300w, ${__cdn__}/wp-content/uploads/2021/07/Under-Armour-Curry-9-700x350.jpeg 700w, ${__cdn__}/wp-content/uploads/2021/07/Under-Armour-Curry-9-768x384.jpeg 768w, ${__cdn__}/wp-content/uploads/2021/07/Under-Armour-Curry-9.jpeg 1020w`}
                      sizes="(max-width: 300px) 100vw, 300px"
                    />{" "}
                  </a>
                </div>
                <div className="su-post-title col-6 col-sm-12">
                  <a
                    style={{ color: "black", fontWeight: 700 }}
                    href="https://www.thehoopsgeek.com/best-basketball-shoes/"
                  >
                    The 20 Best Basketball Shoes in 2022
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-6 col-12"
              style={{ marginBottom: "15px" }}
            >
              <div className="row" id="su-post-14491">
                <div className="col-6 col-sm-12">
                  <a href="https://www.thehoopsgeek.com/best-outdoor-basketball-shoes/">
                    <img
                      width={300}
                      height={150}
                      src={
                        __cdn__ +
                        "/wp-content/uploads/2018/03/Outdoor-Basketball-Shoes-300x150.jpg"
                      }
                      className="su_related_thumbnail wp-post-image"
                      alt=""
                      loading="lazy"
                      srcSet={`${__cdn__}/wp-content/uploads/2018/03/Outdoor-Basketball-Shoes-300x150.jpg 300w, ${__cdn__}/wp-content/uploads/2018/03/Outdoor-Basketball-Shoes-700x350.jpg 700w, ${__cdn__}/wp-content/uploads/2018/03/Outdoor-Basketball-Shoes-768x384.jpg 768w,  ${__cdn__}/wp-content/uploads/2018/03/Outdoor-Basketball-Shoes.jpg 1600w`}
                      sizes="(max-width: 300px) 100vw, 300px"
                    />{" "}
                  </a>
                </div>
                <div className="su-post-title col-6 col-sm-12">
                  <a
                    style={{ color: "black", fontWeight: 700 }}
                    href="https://www.thehoopsgeek.com/best-outdoor-basketball-shoes/"
                  >
                    The Best Outdoor Basketball Shoes
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-6 col-12"
              style={{ marginBottom: "15px" }}
            >
              <div className="row" id="su-post-14461">
                <div className="col-6 col-sm-12">
                  <a href="https://www.thehoopsgeek.com/best-cushion-basketball-shoes/">
                    <img
                      width={300}
                      height={150}
                      src={`${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes-300x150.jpeg`}
                      className="su_related_thumbnail wp-post-image"
                      alt=""
                      loading="lazy"
                      srcSet={`${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes-300x150.jpeg 300w, ${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes-700x350.jpeg 700w, ${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes-768x384.jpeg 768w, ${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes.jpeg 1536w, ${__cdn__}/wp-content/uploads/2018/03/Cushion-Basketball-Shoes.jpeg 2000w`}
                      sizes="(max-width: 300px) 100vw, 300px"
                    />{" "}
                  </a>
                </div>
                <div className="su-post-title col-6 col-sm-12">
                  <a
                    style={{ color: "black", fontWeight: 700 }}
                    href="https://www.thehoopsgeek.com/best-cushion-basketball-shoes/"
                  >
                    The 10 Most Comfortable Basketball Shoes With Great Cushion
                  </a>
                </div>
              </div>
            </div>

            <div
              className="col-lg-3 col-sm-6 col-12"
              style={{ marginBottom: "15px" }}
            >
              <div className="row" id="su-post-8080">
                <div className="col-6 col-sm-12">
                  <a href="https://www.thehoopsgeek.com/best-ankle-support-basketball-shoes/">
                    <img
                      width={300}
                      height={150}
                      src={`${__cdn__}/wp-content/uploads/2018/06/Basketball_Ankle_Braces-300x150.jpg`}
                      className="su_related_thumbnail wp-post-image"
                      alt=""
                      loading="lazy"
                      srcSet={`${__cdn__}/wp-content/uploads/2018/06/Basketball_Ankle_Braces-300x150.jpg 300w, ${__cdn__}/wp-content/uploads/2018/06/Basketball_Ankle_Braces.jpg 654w?`}
                      sizes="(max-width: 300px) 100vw, 300px"
                    />{" "}
                  </a>
                </div>
                <div className="su-post-title col-6 col-sm-12">
                  <a
                    style={{ color: "black", fontWeight: 700 }}
                    href="https://www.thehoopsgeek.com/best-ankle-support-basketball-shoes/"
                  >
                    Best 10 Basketball Shoes for Ankle Support{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({ ...state.data }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(Footer);
